export const TID = {
    nav: {
        root: "sn-nav",
        logo: "sn-nav-logo",
        linkManifesto: "sn-nav-link-manifesto",
        linkComeFunziona: "sn-nav-link-come-funziona",
        linkCodici: "sn-nav-link-codici",
        linkFaq: "sn-nav-link-faq",
        cta: "sn-nav-cta-waitlist",
        mobileToggle: "sn-nav-mobile-toggle",
    },
    hero: {
        root: "sn-hero",
        eyebrow: "sn-hero-eyebrow",
        headline: "sn-hero-headline",
        subtitle: "sn-hero-subtitle",
        ctaPrimary: "sn-hero-cta-primary",
        ctaSecondary: "sn-hero-cta-secondary",
        shield: "sn-hero-shield",
    },
    marquee: "sn-marquee",
    manifesto: {
        root: "sn-manifesto",
        chapter: (n) => `sn-manifesto-chapter-${n}`,
    },
    how: {
        root: "sn-how",
        step: (n) => `sn-how-step-${n}`,
    },
    features: {
        root: "sn-features",
        card: (n) => `sn-features-card-${n}`,
    },
    coverage: {
        root: "sn-coverage",
        item: (n) => `sn-coverage-item-${n}`,
    },
    testimonials: {
        root: "sn-testimonials",
    },
    faq: {
        root: "sn-faq",
        item: (n) => `sn-faq-item-${n}`,
    },
    finalCta: {
        root: "sn-final-cta",
        input: "sn-final-cta-input",
        submit: "sn-final-cta-submit",
    },
    footer: {
        root: "sn-footer",
    },
};
